import React from 'react'
import { Icon } from 'antd'

import { renderFormattedMessage } from '../../utils'
import './MessageList.scss'

const MessageList = ({ messages, showTyping = false }) => {
  if (!messages.length && !showTyping) return null

  return (
    <div className="creative-direction-chat__phase-messages">
      {messages.map(item => (
        <div
          className={`creative-direction-chat__message creative-direction-chat__message--${item.role}`}
          key={item.id}
        >
          <div className="creative-direction-chat__avatar">
            <Icon type={item.role === 'assistant' ? 'robot' : 'user'} />
          </div>
          <div className="creative-direction-chat__bubble">
            <div className="creative-direction-chat__role">
              {item.role === 'assistant' ? 'AI' : 'You'}
            </div>
            <div className="creative-direction-chat__content">
              {item.role === 'assistant'
                ? renderFormattedMessage(item.content)
                : item.content}
              {item.streaming ? (
                <span className="creative-direction-chat__cursor" />
              ) : null}
            </div>
          </div>
        </div>
      ))}

      {showTyping ? (
        <div className="creative-direction-chat__message creative-direction-chat__message--assistant">
          <div className="creative-direction-chat__avatar">
            <Icon type="robot" />
          </div>
          <div className="creative-direction-chat__bubble">
            <div className="creative-direction-chat__role">AI</div>
            <div className="creative-direction-chat__typing">
              <span />
              <span />
              <span />
            </div>
          </div>
        </div>
      ) : null}
    </div>
  )
}

export default MessageList
